import { useState, useEffect } from 'react';
import {
  DESKTOP_VIEW_PORT,
  IPAD_AIR_LANDSCAPE_VIEW_PORT,
  IPAD_AIR_VIEW_PORT,
  IPAD_PRO_LANDSCAPE_VIEW_PORT
} from '../constants/defaults';

/**
 * @returns Boolen Based of browser viewport
 */
export default function useIsDesktop() {
  const getIsDesktop = () =>
    typeof window !== 'undefined'
      ? window?.innerWidth > DESKTOP_VIEW_PORT &&
        !(
          window?.innerHeight === DESKTOP_VIEW_PORT &&
          window?.innerWidth === IPAD_PRO_LANDSCAPE_VIEW_PORT
        ) &&
        !(
          window?.innerHeight === IPAD_AIR_VIEW_PORT &&
          window?.innerWidth === IPAD_AIR_LANDSCAPE_VIEW_PORT
        )
      : false;
  const [isDesktop, setIsDesktop] = useState(getIsDesktop());

  useEffect(() => {
    const onResize = () => {
      setIsDesktop(getIsDesktop());
    };
    window.addEventListener('resize', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, []);

  return isDesktop;
}
